import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import type { ApexOptions } from 'apexcharts';
@Injectable({
  providedIn: 'root'
})
export class Co2SavingsService {

  private isBrowser: boolean;
  private chart: any | null = null; // ApexCharts instance

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  async loadChart(): Promise<void> {
    if (!this.isBrowser) return;

    try {
      const ApexCharts = (await import('apexcharts')).default;

      const chartElement = document.querySelector(
        '#crm_lead_conversation_chart'
      ) as HTMLElement | null;

      if (!chartElement) {
        console.warn('Co2SavingsService: element #crm_lead_conversation_chart not found');
        return;
      }

      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }

      const options :ApexOptions  = {
        series: [
          {
            name: 'CO₂ Savings',
            data: [23, 20, 21, 19]
          }
        ],
        chart: {
          type: 'area',
          height: 100,
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        colors: ['#796df6'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'stepline',
          width: 2
        },

        labels: [
          '10 Mar 2024',
          '11 Mar 2024',
          '12 Mar 2024',
          '13 Mar 2024'
        ],
        xaxis: {
          type: 'datetime',
          axisBorder: {
            show: false,
            color: '#e0e0e0'
          },
          axisTicks: {
            show: false,
            color: '#e0e0e0'
          },
          labels: {
            show: false,
            style: {
              colors: '#919aa3',
              fontSize: '14px'
            }
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          labels: {
            show: false,
            style: {
              colors: '#919aa3',
              fontSize: '14px'
            }
          }
        },
        legend: {
          show: false
        },
        grid: {
          show: false,
          strokeDashArray: 5,
          borderColor: '#e0e0e0'
        },
        tooltip: {
          shared: true,
          y: {
            formatter: (val: any) => {
              const num = Number(val);
              if (Number.isFinite(num)) {
                return num.toFixed(2) + ' %';
              }
              return '';
            }
          }
        }
      };

      this.chart = new ApexCharts(chartElement, options);
      this.chart.render();

    } catch (error) {
      console.error('Error loading ApexCharts (Co2Savings):', error);
    }
  }

  destroyChart(): void {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
